import RemoveStayAlertModal from './RemoveStayAlertModal';
export default RemoveStayAlertModal;
